// eslint-disable-next-line
import Register from "./components/Register";
import ipConfig from "./ipConfig.json";
// eslint-disable-next-line
import { Route, Switch } from "react-router-dom";
import Login from "./components/Login";
// eslint-disable-next-line
import Products from "./components/Products";
import Checkout from "./components/Checkout";
import Thanks from "./components/Thanks"

export const config = {
  endpoint: `https://qkart-frontend-tan.herokuapp.com/api/v1`,
};

function App() {
  return (
    <div className="App">
    <Switch>
      {/* TODO: CRIO_TASK_MODULE_LOGIN - To add configure routes and their mapping */}
      <Route path="/register">
           <Register />
        </Route>
          <Route path="/login">
           <Login />
        </Route>
        <Route path="/products">
           <Products />
        </Route>
        <Route path="/checkout">
           <Checkout />
        </Route>
        <Route path="/thanks">
           <Thanks />
        </Route>
        <Route path="/">
           <Products />
        </Route>
          </Switch>
    </div>
  );
}

export default App;

/* 
curl 'http://localhost:8082/api/v1/user/addresses' \
  -H 'Authorization: Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6ImNyaW8uZG8iLCJpYXQiOjE2NDg4MDU4NzIsImV4cCI6MTY0ODgyNzQ3Mn0.DAvnEfYP0M8_fFguDbmtEaWh9S5z2SWeWhNxcYIsHwQ' \
  -H 'Content-Type: application/json' \
  --data-raw '{"address":"Test address\n12th street, Mumbai"}' \ */